import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import LoginPage from "@/pages/LoginPage";
import POSPage from "@/pages/POSPage";
import InventoryPage from "@/pages/InventoryPage";
import HistoryPage from "@/pages/HistoryPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import LiveCatalogPage from "@/pages/LiveCatalogPage";
import LiveOrdersPage from "@/pages/LiveOrdersPage";
import LiveCollectionsPage from "@/pages/LiveCollectionsPage";
import LiveOperationsPage from "@/pages/LiveOperationsPage";
import CashRegisterPage from "@/pages/CashRegisterPage";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-accent" />
    </div>
  );
}

function ProtectedLayout() {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Outlet />
    </div>
  );
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!user || user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/" replace />;
  return <LoginPage />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<POSPage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/cash" element={<AdminRoute><CashRegisterPage /></AdminRoute>} />
              <Route path="/analytics" element={<AdminRoute><AnalyticsPage /></AdminRoute>} />
              <Route path="/live/catalog" element={<AdminRoute><LiveCatalogPage /></AdminRoute>} />
              <Route path="/live/orders" element={<AdminRoute><LiveOrdersPage /></AdminRoute>} />
              <Route path="/live/collections" element={<AdminRoute><LiveCollectionsPage /></AdminRoute>} />
              <Route path="/live/operations" element={<AdminRoute><LiveOperationsPage /></AdminRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
